'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'LandCategoryRestService',
    function ($modal, LandCategoryRestService) {

        return {
            edit: edit,
            create: create,
            api: LandCategoryRestService
        };

        function create() {
            return $modal.open({
                template: require('../view/land-category-modal-create.html'),
                controller: 'LandCategoryModalCreateController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: false,
                resolve: {
                    landCategory: function () {
                        return {};
                    }
                }
            });
        }

        function edit(item) {
            return $modal.open({
                template: require('../view/land-category-modal-create.html'),
                controller: 'LandCategoryModalCreateController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: false,
                resolve: {
                    landCategory: function () {
                        return item;
                    }
                }
            });
        }

    }];